export default "__VITE_ASSET__CTdIcVdK__"